// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\shared\\\\ImageGrid.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\shared\\ImageGrid.tsx");
  import.meta.hot.lastModified = "1757171103351.3674";
}
// REMIX HMR END

import { cn } from "~/lib/utils";
export function ImageGrid({
  items,
  className,
  variant = "triple",
  showBorders = true
}) {
  return <div className={cn(showBorders && "border-y border-[rgba(18,18,18,0.2)]", className)}>
      <div className="flex overflow-x-auto gap-0 scrollbar-hide snap-x snap-mandatory">
        {items.map((item, index) => {
        const isLastItem = index === items.length - 1;
        const isFirstItem = index === 0;
        return <div key={item.id} onClick={item.onClick} className={cn("group flex-shrink-0 flex flex-col items-center pt-4 sm:pt-8 lg:pt-12 snap-center", item.onClick && "cursor-pointer", showBorders && !isLastItem && "border-r border-[rgba(18,18,18,0.2)]", isFirstItem && "ml-4 sm:ml-6", isLastItem && "mr-4 sm:mr-6")}>
              <div className="w-[240px] sm:w-[320px] lg:w-[380px] h-[240px] sm:h-[360px] lg:h-[440px] overflow-hidden px-4 sm:px-6 lg:px-8">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-101 transition-transform duration-500" />
              </div>

              <div className="p-3 sm:p-4 lg:p-6">
                <h3 className="text-[12px] sm:text-[14px] lg:text-[18px] font-medium uppercase tracking-[0.02em] text-[#121212] font-clash-grotesk text-center">
                  {item.title}
                </h3>
              </div>
            </div>;
      })}
      </div>
    </div>;
}
_c = ImageGrid;
var _c;
$RefreshReg$(_c, "ImageGrid");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;